import { DomainCriteria } from 'core_main/api/settings/types';

import { getStore } from 'core_main/store';
import { IsUrlAllowedParameters, IsUrlAllowedResponse } from './types';

export const validateIsUrlAllowedParameters = (
  parameters: IsUrlAllowedParameters,
) => {
  const url = parameters?.url;

  if (typeof url !== 'string') {
    throw Error('A url must be provided.');
  }

  return undefined;
};

export const createIsUrlAllowedResponse = (
  allowed: boolean,
): IsUrlAllowedResponse => {
  return {
    allowed,
  };
};
export const determineConditions = (
  criteria: DomainCriteria[],
  location: string,
  conditional: 'and' | 'or',
) => {
  let denied = true;
  const locationNoTrailingSlash = location.replace(/\/$/, '');

  if (!criteria) return false;
  // eslint-disable-next-line no-restricted-syntax
  for (const condition of criteria) {
    const { operator, value } = condition.website_url;
    const equalsOperator = operator === 'equals';
    const notEqualsOperator = operator === 'not_equals';
    const containsOperator = operator === 'contains';
    const notContainsOperator = operator === 'not_contains';

    // Admins may forget to add a trailing slash to a URL in the admin,
    //  we do not want to exclude those locations, so compare the location and
    //  the location without a trailing slash (if the slash exists)
    const locationIsEqual =
      location === value || locationNoTrailingSlash === value;

    if (
      (containsOperator && location.includes(value)) ||
      (notContainsOperator && !location.includes(value)) ||
      (equalsOperator && locationIsEqual) ||
      (notEqualsOperator && location !== value)
    ) {
      denied = false;
    } else if (conditional === 'and') {
      denied = true;
      break;
    }
  }

  return denied;
};

export const isUrlDenied = (currentLocation: string) => {
  const store = getStore();
  const { domainCriteria } = store.settings;

  if (!domainCriteria) return false;

  const orConditions = domainCriteria.or;
  const andConditions = domainCriteria.and;

  const deniedInAndConditions = determineConditions(
    andConditions,
    currentLocation,
    'and',
  );

  const deniedInOrConditions = determineConditions(
    orConditions,
    currentLocation,
    'or',
  );

  let isDenied = false;

  if (andConditions && orConditions) {
    const andPasses = !deniedInAndConditions && !deniedInOrConditions;
    isDenied = !andPasses;
  } else if (orConditions) {
    isDenied = deniedInOrConditions;
  } else if (andConditions) {
    isDenied = deniedInAndConditions;
  }

  return isDenied;
};
